import { PublishTermsErrorContainer } from '../PublishTermsError';
import * as React from 'react';

import { PublicationLayout } from '../PublicationLayout/PublicationLayout';
import { PublicationTitle } from '../PublicationTitle';

export const PublicationError = () => {
  return <PublicationLayout content={<PublishTermsErrorContainer />} title={<PublicationTitle />} />;
};
